import type * as React from 'react'

import {closestUpTo} from '../../../../utils/dom'
import type {PolicyEntry} from '../CleanupProjectPage.types'

export const isPolicyCustom = (policy: PolicyEntry): boolean =>
  Boolean(
    policy.everythingPolicy?.ownPolicy ||
      policy.historyPolicy?.ownPolicy ||
      policy.artifactsPolicy?.ownPolicy ||
      policy.options.ownPrevent,
  )
export const shouldPreventClickOnRow: (
  arg0: React.SyntheticEvent<any>,
) => boolean | null | undefined = e => {
  if (!(e.target instanceof Node) || !e.currentTarget.contains(e.target)) {
    return true
  }

  if (closestUpTo(e.target, e.currentTarget, 'a,button,label') != null) {
    return true
  }

  const selection = window.getSelection()
  return selection != null && selection.toString().length > 0
}
